<template>
  <div>

  </div>
</template>

<script>
import { selectVisitinfos } from "@/request/api.js";
import { Base64 } from "js-base64";
import { Dialog } from "vant";
export default {
  data() {
    return {
      user: {},
      bVisitinfoList: {}
    }
  },
  created() {
    if(sessionStorage.getItem("user") == null){
      let hspCode = window.location.href;
      let token = hspCode.split("?")[1];
      token = decodeURIComponent(token).replace(/\s/g, "+"); // decodeURIComponent() 对编码后的 URI 进行解码;
      let user = Base64.decode(token);
      this.user = JSON.parse(user);
      this.getLists();
      sessionStorage.setItem("user", user);
      sessionStorage.setItem("openid", this.user.userOpen.openid);
    }
  },
  methods: {
    async getLists() {
      let res = await selectVisitinfos({ openid: this.user.userOpen.openid });
      this.bVisitinfoList = res.data.obj;
      this.bVisitinfoList.forEach(item => {
        if (item.style == 1) {
          this.currentSel = item;
          sessionStorage.setItem("card", JSON.stringify(item));
        }
      });
      if (this.bVisitinfoList.length == 0) {
        Dialog.alert({
          message: "无就诊卡请前往建卡页面"
        }).then(() => {
          this.$router.push("/AddVisitors");
        });
      }
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Judgment/Judgment.vue